export default __webpack_public_path__ + "static/media/P_wdt_c_cap_3.3b6a4f10.mp3";